// extracted by mini-css-extract-plugin
var _1 = "modalChangeDiscip-module_agreement__p1X6VV";
var _2 = "modalChangeDiscip-module_btnContainer__SP6_Za";
var _3 = "modalChangeDiscip-module_button_bright__GAX9ew";
var _4 = "modalChangeDiscip-module_button_transparent__FbpRef";
var _5 = "modalChangeDiscip-module_dialogActions__zploQ1";
var _6 = "modalChangeDiscip-module_dialogContnent__wq3NaG";
var _7 = "modalChangeDiscip-module_dialog_paper__aTJ6Hf";
var _8 = "modalChangeDiscip-module_gray_text__qXI14a";
var _9 = "modalChangeDiscip-module_icon__IGOjk1";
var _a = "modalChangeDiscip-module_input__yenMeb";
var _b = "modalChangeDiscip-module_login__E1kIas";
var _c = "modalChangeDiscip-module_notificationCheckbox__QDq_L4";
export { _1 as "agreement", _2 as "btnContainer", _3 as "button_bright", _4 as "button_transparent", _5 as "dialogActions", _6 as "dialogContnent", _7 as "dialog_paper", _8 as "gray_text", _9 as "icon", _a as "input", _b as "login", _c as "notificationCheckbox" }
